<template>
  <select-countries
    style="max-width: none"
    :isShowSelectedItemIcon="false"
    :staticCountries="true"
    :chosen-countries="selectedCountries"
    :countries="countries"
  >
    <template #item="slotProps">
      <v-list-item-content class="withdraw-countries-content d-flex" @click.stop>
        <div class="counties-content-wrapper">
          <v-list-item-icon class="counties-content-wrapper-icon pa-0 ma-0">
            <lang-circle class="pb-1" :country="slotProps.item.value"></lang-circle>
          </v-list-item-icon>
          <v-list-item-title class="d-inline-block">
            <div class="country-item">
              <div class="withdraw-countries-label ml-2 mr-3">
                {{ slotProps.item.text }}
              </div>
              <div>
                <v-text-field
                  style="max-width: 110px"
                  class="pa-0 ma-0"
                  :disabled="disabled"
                  :placeholder="`${item.limits.default[keyValue]}` || '0'"
                  :label="`${item.limits[slotProps.item.value]?.[keyValue] || 0}`"
                  :value="item.limits[slotProps.item.value]?.[keyValue] || `${item.limits.default?.[keyValue]}`"
                  @input="value => $emit('input', {value, slotProps})"
                  hide-details
                  single-line
                ></v-text-field>
              </div>
            </div>
          </v-list-item-title>
        </div>
      </v-list-item-content>
    </template>
  </select-countries>
</template>

<script>
  import LangCircle from '@/components/core/SelectLang/LangRow/LangCircle.vue'
  import SelectCountries from '@/components/core/SelectCountries.vue'

  export default {
    name: 'SelectEditableCountries',
    components: { SelectCountries, LangCircle },
    emits: [ 'input' ],
    props: {
      selectedCountries: {
        type: Array,
        required: true,
      },
      countries: {
        type: Array,
        required: true,
      },
      item: {
        type: Object,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      keyValue: {
        type: String,
        required: true,
      },
    },
  }
</script>

<style scoped>
  .counties-content-wrapper-icon {
    padding: 0;
    margin-right: 12px !important;
  }
</style>
